import { getActionIcon } from './feedbackUtils';

interface CompactActionBreakdownProps {
    entries: [string, number][];
}

export const CompactActionBreakdown = ({ entries }: CompactActionBreakdownProps) => {
    if (entries.length === 0) {
        return <p className="text-xs text-gray-500">No actions</p>;
    }

    // Calculate how many items per row (split roughly in half)
    const midpoint = Math.ceil(entries.length / 2);
    const firstRow = entries.slice(0, midpoint);
    const secondRow = entries.slice(midpoint);

    return (
        <div className="flex flex-col gap-1.5">
            <div className="flex flex-wrap items-center gap-2">
                {firstRow.map(([action, count]) => (
                    <div key={action} title={action} className="flex items-center gap-1 bg-white/60 px-2 py-1 rounded">
                        {getActionIcon(action, { size: 14, className: 'text-gray-600' })}
                        <span className="text-xs font-semibold text-gray-900">{count}</span>
                    </div>
                ))}
            </div>
            {secondRow.length > 0 && (
                <div className="flex flex-wrap items-center gap-2">
                    {secondRow.map(([action, count]) => (
                        <div key={action} title={action} className="flex items-center gap-1 bg-white/60 px-2 py-1 rounded">
                            {getActionIcon(action, { size: 14, className: 'text-gray-600' })}
                            <span className="text-xs font-semibold text-gray-900">{count}</span>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

